<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains equities_details">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" v-if="form.staffHeadImg" :src="form.staffHeadImg"></el-avatar>
              <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ form.staffInfo }}</p>
              </div>
            </div>
          </div>
         
          <div class="pl10 pr10 mt20 nav_list">
            <div v-for="item,index in form.itemList" :key="index" class="p10 mb10 cur" style="padding: 10px;border: 1px solid #ccc;" @click="openClick(item)">
              <span>{{ item.subsidyTypeCn }}</span> <span class="ml10 nav_list_tag" v-if="item.addFlag == 'yes'">可申请</span>
            </div>
          </div>
        </div>
      </div>
    </drawer>
    <equitiesApply ref="equitiesApplyRef" @change="handleChange"></equitiesApply>
  </div>
</template>

<script>
import minxin from "../../../../assets/javascript/minxin.js";
import drawer from "../../../../components/common/drawer";
import equitiesApply from "./equitiesApply.vue";
export default {
  mixins: [minxin],
  components: {
    drawer,
    equitiesApply
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "店员权益详情",
      dialogHide: false,
      headerImg: require("../../../../assets/images/headerImg.png"),
      form: {
        itemList: []
      },
    };
  },
  methods: {
    //  页面初始化函数
    init(org) {
      this.$api.get(this.$url.subsidyApply.staffSubsidyRightDetail, {
        staffId: org,
      }).then(res => {
        if (res) {
          this.addEditShow = true;
          this.form = res;
        }
      }).catch(error => {});
    },
    openClick (item) {
      this.$refs.equitiesApplyRef.init({
        subsidyType: item.subsidyType,
        subsidyTypeCn: item.subsidyTypeCn,
        staffId: this.form.staffId,
        staffName: this.form.staffName,
        addFlag: item.addFlag
      });
    },
    handleChange () {
      this.$emit("change", true);
      this.init(this.form.staffId); 
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
.equities_details {
  .nav_list {
    .nav_list_tag {
      display: inline-block;
      padding: 2px 4px;
      color: #257FFA;
	    background: #E7F5FF;
    }
  }
  .member-msg {
    padding: 10px 10px 0;
    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;

      .member-box {
        margin-left: 10px;

        .mobile {
          line-height: 1.6;
          margin-right: 10px;
        }
      }
    }
  }
}

</style>